import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { likeComment, likeGameComment } from '~/api';
import { LikeCommentRequest } from '~/types';
import { LikeGameCommentRequest } from '~/types/missionGameApi';
import useToast from '~/store/useToast';
import useUpdateCommentList from './useUpdateCommentList';
import useUpdateGameCommentList from './useUpdateGameCommentList';

export const useSaveCommentLikeMutation = () => {
  const { showToast } = useToast();
  const { updateCommentLike } = useUpdateCommentList();
  return useMutation({
    mutationFn: (newComment: LikeCommentRequest) => likeComment(newComment),
    onSuccess: ({ status }, request) => {
      updateCommentLike(request, 'save');
    },

    onError: (error) => {
      console.error(error);
      showToast('error', 'cannot proceed');
    },
  });
};

export const useSaveGameCommentLikeMutation = () => {
  const { showToast } = useToast();
  const { updateGameCommentLike } = useUpdateGameCommentList();

  return useMutation({
    mutationFn: (newComment: LikeGameCommentRequest) =>
      likeGameComment(newComment),
    onSuccess: ({ status }, request) => {
      updateGameCommentLike({
        request,
        game_id: request.game_id,
        type: 'save',
      });
    },

    onError: (error) => {
      console.error(error);
      showToast('error', 'cannot proceed');
    },
  });
};
